import axios from '../../../../shared/axios/axios';

import * as actionTypes from '../constants/actionTypes';

import { validateObj } from '../../../../shared/utils';

const getOriginalPdfFormsStart = () => {
  return {
    type: actionTypes.ORIGINAL_PDF_FORMS_GET_ORIGINAL_PDF_FORMS_START,
  };
};

const getOriginalPdfFormsSuccess = (data) => {
  return {
    type: actionTypes.ORIGINAL_PDF_FORMS_GET_ORIGINAL_PDF_FORMS_SUCCESS,
    data,
  };
};

const getOriginalPdfFormsFail = (error) => {
  return {
    type: actionTypes.ORIGINAL_PDF_FORMS_GET_ORIGINAL_PDF_FORMS_FAIL,
    error: error,
  };
};

export const getOriginalPdfForms = (pageRequest) => {
  return (dispatch) => {
    dispatch(getOriginalPdfFormsStart());
    const url = `/original-form/get-forms-list`;

    axios
      .post(url, validateObj(pageRequest))
      .then((response) => dispatch(getOriginalPdfFormsSuccess(response.data)))
      .catch((err) => dispatch(getOriginalPdfFormsFail(err)));
  };
};

const downloadFlattenPdfFormStart = () => {
  return {
    type: actionTypes.ORIGINAL_PDF_FORMS_DOWNLOAD_FLATTEN_PDF_FORM_START,
  };
};

const downloadFlattenPdfFormSuccess = (data) => {
  return {
    type: actionTypes.ORIGINAL_PDF_FORMS_DOWNLOAD_FLATTEN_PDF_FORM_SUCCESS,
    data,
  };
};

const downloadFlattenPdfFormFail = (error) => {
  return {
    type: actionTypes.ORIGINAL_PDF_FORMS_DOWNLOAD_FLATTEN_PDF_FORM_FAIL,
    error: error,
  };
};

export const downloadFlattenPdfForm = (params) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(downloadFlattenPdfFormStart());
      const url = `/original-form/download-pdf-form`;

      axios
        .get(url, { responseType: 'blob', params: validateObj({ ...params, flatten: true }) })
        .then((response) => {
          dispatch(downloadFlattenPdfFormSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(downloadFlattenPdfFormFail(err));
          reject(err);
        });
    });
  };
};

const downloadOriginalPdfFormStart = () => {
  return {
    type: actionTypes.ORIGINAL_PDF_FORMS_DOWNLOAD_ORIGINAL_PDF_FORM_START,
  };
};

const downloadOriginalPdfFormSuccess = (data) => {
  return {
    type: actionTypes.ORIGINAL_PDF_FORMS_DOWNLOAD_ORIGINAL_PDF_FORM_SUCCESS,
    data,
  };
};

const downloadOriginalPdfFormFail = (error) => {
  return {
    type: actionTypes.ORIGINAL_PDF_FORMS_DOWNLOAD_ORIGINAL_PDF_FORM_FAIL,
    error: error,
  };
};

export const downloadOriginalPdfForm = (params) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(downloadOriginalPdfFormStart());
      const url = `/original-form/download-pdf-form`;

      axios
        .get(url, { responseType: 'blob', params: validateObj(params) })
        .then((response) => {
          new Response(response.data).arrayBuffer().then((result) => {
            dispatch(downloadOriginalPdfFormSuccess(result));
            resolve(result);
          });
        })
        .catch((err) => {
          dispatch(downloadOriginalPdfFormFail(err));
          reject(err);
        });
    });
  };
};
